import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { RijksregisterNummerIcon } from "../../atoms/icons/RijksregisterNummerIcon";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const RijksregisterNummer = (props: AllProps) => {
    return (<Caption {...props} caption={props.label || "Rijksregisternummer"} icon={<RijksregisterNummerIcon />}>
        {props.value}
    </Caption>)
}

